<template>
<v-container fluid class="pa-0">
<!-- Formulaire -->
    <v-card fluid class="ma-2 pa-3 elevation-0 rounded-xxl micorise-v-card">
    <v-card-title >
        Équipe {{ item.tem_name }}
        <v-spacer></v-spacer>
        <v-chip outlined color="secondary">
                <v-icon left>mdi-information-outline</v-icon>Modification: {{ $date(item.tem_updated_at).format('DD MMMM YYYY') }}
        </v-chip>
    </v-card-title>
    <v-row no-gutters>
        <v-col cols="12" md="6" class="pa-2">
            <v-text-field outlined dense class="rounded-lg" label="Nom de l'équipe" v-model="item.tem_name"></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pa-2">
            <v-select v-if="!loading.fetchData" :items="stateListByGroup['GEN']" item-text="sta_label" item-value="sta_id" 
                v-model="item.tem_sta_id" label="Statut" single-line outlined dense></v-select>
        </v-col>
        <v-col cols="12" md="6" class="pa-2">
            <AutocompleteMulti v-if="!loading.fetchData"
                :title="'Chef d\'équipe'" :ressource="'users'" :disabled="false"
                :listObject.sync="item.tem_usr_id_leader" :listParent.sync="autoCompleteSource.userList" 
                :fields="{ index: 'id', text:'lastName,firstName', autofocus: false, deletablechips: true,
                    search:'usr_middleName', preprendIcon:'mdi-account-tie', multiSelect:false, prefetch: true, params:'usr_role=TEAM_LEADER' 
            }"></AutocompleteMulti>
        </v-col>
    </v-row>
    <v-row class="pr-6">
        <v-col cols="12" md="12" class="pl-2 pr-2">
            <AutocompleteMulti 
                :title="'Membres'" :ressource="'users'" :disabled="false"
                :listObject.sync="item._pivot.users" :listParent.sync="autoCompleteSource.userList" 
                :fields="{ index: 'id', text:'lastName,firstName', autofocus: false, deletablechips: true,
                    search:'usr_middleName', preprendIcon:'mdi-account-group', multiSelect:true, prefetch: true, params:'' 
            }"></AutocompleteMulti>
        </v-col>
        <v-col cols="12" md="12" class="pl-2 pr-2">
            <AutocompleteMulti 
                :title="'Matériel affecté'" :ressource="'equipments'" :disabled="false"
                :listObject.sync="item._pivot.equipments" :listParent.sync="autoCompleteSource.equipmentList" 
                :fields="{ index: 'equ_id', text:'equ_name', autofocus: false, deletablechips: true,
                    search:'equ_name', preprendIcon:'mdi-tools', multiSelect:true, prefetch: true, params:'' 
            }"></AutocompleteMulti>
        </v-col>
    </v-row>
    <v-divider class="ma-2"></v-divider>
    <v-subheader class="pl-0"><v-icon class="mr-1">mdi-map-search</v-icon>Droits d'accès géographique</v-subheader>
    <v-row class="pr-6">
        <v-col cols="12" md="12" class="pl-2 pr-2">
            <AutocompleteMulti 
                :title="'Calques autorisés'" :ressource="'layersassoc'" :disabled="false"
                :listObject.sync="item._pivot.layers" :listParent.sync="autoCompleteSource.layerList" 
                :fields="{ index: 'lra_id', text:'lra_source_id', autofocus: false, deletablechips: true,
                    search:'lra_source_id', preprendIcon:'mdi-layers', multiSelect:true, prefetch: true, params:'' 
            }"></AutocompleteMulti>
            <p class="text-caption grey--text pl-2">Si aucun calque ni dessin n'est sélectionné, l'équipe voit tous les objets du projet.</p>
        </v-col>
        <v-col cols="12" md="12" class="pl-2 pr-2">
            <AutocompleteMulti v-if="!loading.fetchData"
                :title="'Dessins / secteurs affectés'" :ressource="'drawing'" :disabled="true"
                :listObject.sync="item._pivot.drawings" :listParent.sync="autoCompleteSource.drawingList" 
                :fields="{ index: 'dra_id', text:'dra_cad_uid', autofocus: false, deletablechips: true,
                    search:'dra_cad_uid', preprendIcon:'mdi-drawing', multiSelect:true, prefetch: false, params:'' 
            }"></AutocompleteMulti>
            <p class="text-caption grey--text pl-2">Les dessins sélectionnés priment sur les calques. Si aucun dessin n'est sélectionné, les calques ci-dessus déterminent les secteurs visibles.</p>
        </v-col>
    </v-row>
    <v-card-actions>
        <v-btn class="rounded-xl" large color="red" v-if="item.tem_id" @click="deleteItem(item)"><v-icon title="Supprimer">mdi-delete</v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-btn class="rounded-xl" large color="success" :loading="loading.fetchData" @click.native="saveItem()" :disabled="loading.fetchData">Enregistrer</v-btn>
        <v-btn class="rounded-xl" large color="primmary" :to="{ name: 'teams-list' }">Retour</v-btn>
    </v-card-actions>
</v-card>
</v-container>
</template>

<script>
import AutocompleteMulti from '@/components/ui/AutocompleteMulti'
import { mapWritableState, mapActions, mapState } from 'pinia'
import { useTeamStore } from '@/stores/team'
import { useStateStore } from '@/stores/state'
import { useUserStore } from '@/stores/user'
import { useEquipmentStore } from '@/stores/equipment'

export default {
    name: 'teams-edit',
    components: { AutocompleteMulti },
    computed: {
        ...mapWritableState(useTeamStore, {item: 'item' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
        ...mapState(useUserStore, {userList: 'itemList' }),
        ...mapState(useEquipmentStore, {equipmentList: 'itemList' }),
    },
    data: function () {
        return {
            loading: { fetchData: true },
            autoCompleteSource: { userList: [], equipmentList: [], layerList: [], drawingList: [] },
        }
    },
    async mounted () {
        this.autoCompleteSource.userList = this.userList
        //this.autoCompleteSource.equipmentList = this.equipmentList

        // Charge les layers et drawings disponibles
        try {
            const layerResp = await this.$http.get('/layersassoc/?per_page=false')
            if( layerResp.data.data && Array.isArray(layerResp.data.data) ){
                this.autoCompleteSource.layerList = layerResp.data.data
            }
        } catch(e) { console.log('layers fetch error:', e) }
        try {
            const drawingResp = await this.$http.get('/drawing/?per_page=false')
            if( drawingResp.data.data && Array.isArray(drawingResp.data.data) ){
                this.autoCompleteSource.drawingList = drawingResp.data.data
            }
        } catch(e) { console.log('drawing fetch error:', e) }

        if( this.$route.params.id && parseInt( this.$route.params.id ) > 0 ){
            await this.fetchItem( this.$route.params.id, '?include=users,equipments,leader,drawings,layers' )
            if( Array.isArray(this.item.drawings) ){
                this.autoCompleteSource.layerList = this.item.drawings
            }

        } else {
            this.RESET_ITEM()
        }
        this.loading.fetchData = false
    },
    methods: {
        ...mapActions(useTeamStore, {fetchItem: 'fetchItem', updateItem: 'updateItem', storeItem: 'storeItem', destroyItem: 'destroyItem', RESET_ITEM: 'RESET_ITEM' }),
        async saveItem () {
            this.loading.fetchData = true
            if( parseInt( this.$route.params.id ) > 0 ){
                await this.updateItem()
            } else {
                await this.storeItem()
            }
            this.$router.push({ path: '/teams' })
        },
        deleteItem(item){
            this.$root.$confirm('Supprimer cette équipe', 'Confirmez vous cette action ?', { color: 'red', width: 400 }).then((confirm) => {
                if( confirm && item.tem_id > 0 ){
                    this.destroyItem(item.tem_id).then( () => {
                        this.$router.push({ path: '/teams' })
                    })
                }
            })
        },
    }
}
</script>
